export enum BiblesActionTypes {
    GET_BIBLES = 'GET_BIBLES',
    DELETE_BIBLE = 'DELETE_BIBLE',
    POST_BIBLE_RIGHTS = 'POST_BIBLE_RIGHTS',
    EXPORT_BIBLE_TO_IMANAGE = 'EXPORT_BIBLE_TO_IMANAGE',
    POST_BIBLE = 'POST_BIBLE',
    GET_BIBLE = 'GET_BIBLE',
}
